var SubmitToRdModule = (function () {
    function SubmitToRdModule() {
    }
    return SubmitToRdModule;
}());
export { SubmitToRdModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/submit-to-rd/submit-to-rd.module.ts.pre-build-optimizer.js